import { useEffect } from 'react';
import { useGlobal } from 'hooks/useGlobal';

const TOUR_SCREEN_KEY = 'TOUR_SCREEN';

/** The tab a screen has open, as last reported. Null on screens without tabs. */
export const useCurrentTourScreen = () => useGlobal<string | null>(TOUR_SCREEN_KEY, null)[0];

/**
 * Tells the tour engine which tab a screen has open, so a tour can belong to one tab.
 *
 * Tabs live in the query string, but `useQueryState` writes it with `replaceState`, which
 * the router never sees. So the screen reports it instead of the engine reading the URL.
 */
export const useTourScreen = (screen: string | null) => {
  const [, setScreen] = useGlobal<string | null>(TOUR_SCREEN_KEY, null);

  useEffect(() => {
    setScreen(screen);
    return () => setScreen(null);
  }, [screen]);
};
